import { render, staticRenderFns } from "./downloadImg.vue?vue&type=template&id=5af5606c&scoped=true"
import script from "./downloadImg.vue?vue&type=script&lang=js"
export * from "./downloadImg.vue?vue&type=script&lang=js"
import style0 from "./downloadImg.vue?vue&type=style&index=0&id=5af5606c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5606c",
  null
  
)

export default component.exports